const SupportArticle = `
  id
  createdAt
  meta
  updatedAt
`;

export default SupportArticle;
